export default __webpack_public_path__ + "static/media/profile-banner.065120f1.webp";